import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
    selector: 'app-close-button',
    templateUrl: './close-button.component.html',
    styleUrls: ['./close-button.component.scss'],
})
export class CloseButtonComponent {

    constructor(
        private modalController: ModalController
    ) { }

    close() {
        this.modalController
            .getTop()
            .then(
                modal => modal.dismiss()
            );
    }

}
